// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> springhouse-townhomes
// Generated: 2026-10-22T20:05:53.490Z
// Counts: 1 design, 67 content, 62 slot group, 1 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>2 - 3 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>2 - 3 Bedroom Townhomes for Rent in Allentown , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Springhouse Townhomes in Allentown, PA, where modern living meets vibrant surroundings. Nestled among cultural gems like the Allentown Art Museum and the Civic Theatre, our community offers spacious two- and three-bedroom floor plans, plus quick access to parks, schools, and major transit hubs. Dive into local favorites!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Unlock the Door to Your Perfect Townhomes Sanctuary</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Springhouse Townhomes in Allentown, PA, luxury meets comfort. Enjoy spacious floor plans ranging from cozy two-bedroom layouts to expansive three-bedroom townhomes. Revel in our pet-friendly community with walking trails, grilling stations, and modern conveniences like high-speed internet and on-site management—all designed for your comfort and lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>See <span data-type=\"field-token\" data-field=\"property_name\"></span> in person</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace life at Springhouse Townhomes in Allentown, PA, where modern living meets nature's beauty. Choose from spacious floor plans featuring gourmet kitchens and vaulted ceilings. Enjoy pet-friendly amenities, scenic walking trails, and convenient online leasing. Your ideal home awaits—step into a lifestyle designed just for you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Springhouse Townhomes in Allentown, PA, find your perfect fit with our thoughtfully designed floor plans, including spacious <a href=\"https://www.springhousetownhomes.com/floor-plans/\">two and three-bedroom</a> options. Whether you desire a cozy retreat or ample living space, we’re here to help! Have questions? Contact our leasing team today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Springhouse Townhomes in Allentown, PA, your ideal living space awaits. With thoughtfully designed two and three-bedroom floor plans, each home seamlessly blends comfort and style. Unveil the potential of your new lifestyle—navigate through our available options and find the perfect layout that suits your needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Immerse yourself in the vibrant lifestyle at Springhouse Townhomes in Allentown, PA. Our spacious <a href=\"https://www.springhousetownhomes.com/floor-plans/\">two and three-bedroom layouts</a> feature modern finishes like granite countertops and stainless steel appliances. Enjoy scenic walking trails, pet-friendly amenities, and cozy corners perfect for grilling. Picture yourself relaxing in our serene courtyard or upgraded townhomes!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Springhouse Townhomes in Allentown, PA, where modern living meets vibrant surroundings. Nestled among cultural gems like the Allentown Art Museum and the Civic Theatre, our community offers spacious two- and three-bedroom floor plans, plus quick access to parks, schools, and major transit hubs. Dive into local favorites!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Townhome Living in Allentown , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">We’re a pet-friendly community and happily welcome cats and dogs. Up to two pets are permitted per apartment. Breed restrictions apply. Please contact the leasing office for details.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Springhouse Townhomes offers thoughtfully designed pet-friendly two or three bedroom townhomes in Allentown with the amenities and extras that make your life comfortable and easy. Enjoy a park-like setting with a scenic center courtyard as well as a fully equipped kitchen and a private patio or balcony. Our luxury community is conveniently located near popular dining, outdoor recreation, and shopping so your next-level living experience extends far beyond your front door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Springhouse Townhomes in Allentown, PA, our inviting two and three-bedroom residences blend comfort with style. Elevate your living experience—access your resident portal today to effortlessly pay rent, schedule maintenance, and manage your home needs. Your seamless lifestyle awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out! At Springhouse Townhomes in Allentown, PA, we offer spacious floor plans, including two and three-bedroom layouts tailored for your lifestyle. Embrace comfort and community living—our team will be in touch soon to help you find your perfect home. Your journey to relaxation starts here!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into your dream home at Springhouse Townhomes in Allentown, PA! We offer spacious two- and three-bedroom floor plans designed for modern living. Ready to envision your new lifestyle? Take a virtual tour today and uncover the perfect blend of comfort and convenience waiting for you!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-4a39-708e-955f-03f8ae23a9d5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious apartment living room with a gray sectional sofa, cozy fireplace, and large arched windows."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-4a6b-751e-93de-48617983ef03.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with white cabinets, gas range, refrigerator, and double-basin sink at Springhouse Townhomes in Allentown, PA."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026a-d441-7169-89e3-dd1cd66e3812.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Person stretching on a yoga mat with a water bottle nearby."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026a-d336-73bb-85b3-594b5c6b3968.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Close-up of a hand loading jeans into a front-loading washing machine."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026a-ccbc-74df-87e0-126491aea7e7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Person pets a calico cat in a bright kitchen."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026a-9444-70f5-964e-f6799670ce23.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright white kitchen with an island, white cabinetry, refrigerator, stove, and microwave."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026c-3f01-76f7-ad68-19e2d59a0bf7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open living and dining area in a modern apartment with round wooden table and fireplace."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026a-852b-70bd-b704-25ee4b21ada5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in apartment with queen bed, nightstands, dresser, and wall-mounted TV."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f3a-721c-b859-f5a785bfedb3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the townhome community with attached garages and a nearby shopping center in Allentown, PA."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fa5a7-d011-744b-841d-cafbe2610f44.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Trexler Memorial Park with mature trees, grassy lawns, and paved walking paths near Springhouse Townhomes."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fa5a5-a640-722a-a3da-5322b3364ce8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cedar Beach Park in Allentown with a tree-lined lake, open green space, and recreation areas."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fa5a7-a06d-70e9-b0ab-c592d90c018a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Allentown Farmers Market, a covered marketplace with local produce, deli, and specialty food vendors."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-7283-72a9-823d-be8ca1de0281.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White gazebo and picnic area in the landscaped community courtyard at Springhouse Townhomes."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026a-b403-71ff-aa84-d6976d22218c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gazebo in a landscaped apartment community courtyard with benches and walking paths."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026a-b21e-73dd-9d9b-4b9ef2347b6e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a townhouse-style apartment community with attached garages and landscaping."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026a-a718-739f-a57c-51be263bb75c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A white gazebo sits in a landscaped courtyard with picnic tables and apartment buildings in view."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$15"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$5"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce6e-4f75-764f-88e7-17e26e0638cf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026c-402b-7382-9d54-0cceb4e755db.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-plan living room with a gray sofa, coffee table, TV over fireplace, dining area, and kitchen island."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019d026a-852b-70bd-b704-25ee4b21ada5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in apartment with queen bed, nightstands, dresser, and wall-mounted TV."
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-4a6b-751e-93de-48617983ef03.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce6e-53b2-756e-92c4-3f69e6a6f7f9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo_media.alt_text"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b11d-72a4-b012-db03fd385b68.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Udder Bar"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Ice Cream & Sweets"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Family-run parlor for housemade ice cream, plus liege waffles, bubble waffles, and edible cookie dough."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-d428-72ab-b863-9226229253cf.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Lehigh Valley Mall"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Split-level family shopping mall with 3 department stores, global brands, restaurants & a play area."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-01ee-733c-9d00-08755f379880.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Trexler Memorial Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Outdoors"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Scenic park with large old trees, grassy lawns & a duck pond, plus paths for cycling & running."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-bc95-75a8-83c0-e1b660f5b78c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Union & Finch"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "American Bistro"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Bright, cozy setting for seasonal American bistro fare amid wood-heavy decor & an old-fashioned bar."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e7ec-7764-ba52-1ac8ba8bd5d2.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Allentown Art Museum"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Art gallery featuring permanent & traveling exhibitions on display along with a cafe & gift shop."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce0a-0be2-749c-aa5b-7a0511f26261.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Lehigh Parkway"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Trails & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Historic park provides running & biking trails through scenic grounds with a creek & covered bridge."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b641-75b2-9b7f-813c168aad52.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Ringers Roost"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Grill"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.7 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Bar & grill offering a diverse American menu in a relaxed setting with sports-centric decor."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-e9d4-72e1-9973-177d935a5c49.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Miller Symphony Hall"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Historic 19th-century theater hosting the Allentown Symphony Orchestra & other musical performances."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-c64e-737c-aba4-f39bc0d8faf3.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bolete"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Fine Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Rustic-chic destination serving a seasonal farm-to-table menu of American cuisine, with a full bar."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-b91e-7265-a8ca-f375f84bbdd1.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Youell's Oyster House"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop & Seafood"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Veteran eatery offering its seafood menu in a remodeled space that includes a rooftop garden."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-f002-701b-aeae-adbbd1727b11.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Frank Banko Alehouse Cinemas"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Independent cinema with 2 screens seating 100 & 200 people showing international & arthouse films."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-bf8a-749e-9cef-02da4987e635.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Wert's Cafe"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Late-Night Eats"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.7 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "This busy, longtime eatery known for its signature burgers also serves other classic American bites."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-258c-76ca-b9a4-c559ee15596b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gazebo and picnic tables in front of apartment buildings"
      }
    }
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-6f21-730d-a4f5-929a04667ffb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a residential community with townhouses and lush landscaping."
      }
    }
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce6e-4f75-764f-88e7-17e26e0638cf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Balcony with seating area overlooking trees and sky"
      }
    }
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166344/019fce09-7283-72a9-823d-be8ca1de0281.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White gazebo and picnic area in a landscaped community courtyard at Springhouse Townhomes in Allentown, PA."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
